import { render, staticRenderFns } from "./vipAction.vue?vue&type=template&id=585d6e76"
import script from "./vipAction.vue?vue&type=script&lang=js"
export * from "./vipAction.vue?vue&type=script&lang=js"
import style0 from "./vipAction.vue?vue&type=style&index=0&id=585d6e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports